import { sendClick, sendImpressions } from 'reaxl-analytics';

import {
    inventoryMediaViewerClick,
    inventoryVehicleConditionHighlightsClick,
    inventoryVideoCompleted,
    inventoryVideoMilestones,
    inventoryVideoPlay,
    mediaGalleryNdsCTAClick,
    mediaSliderMediaClick,
    mediaSliderVhrClick,
    mediaSliderVhrImpression,
    mediaTabClick,
    mediaVideoPhotoClick,
    mediaViewerPagination,
    snap360Click,
    vi360Click,
    viewAllMediaClick,
} from '@/analytics/inventoryAnalyticsHandlers';

import tabTitles from './tabTitles';

const analyticsFunctions = {
    inventoryMediaViewerClick,
    inventoryVehicleConditionHighlightsClick,
    inventoryVideoCompleted,
    inventoryVideoMilestones,
    inventoryVideoPlay,
    mediaGalleryNdsCTAClick,
    mediaTabClick,
    mediaSliderMediaClick,
    mediaSliderVhrClick,
    mediaSliderVhrImpression,
    mediaVideoPhotoClick,
    mediaViewerPagination,
    vi360Click,
    snap360Click,
    viewAllMediaClick,
};

const getAnalyticsData = {
    inventoryMediaViewerClick: ({
        index = 0,
        title,
        isPsxVdp,
        par = '',
    } = {}) => {
        let placement = 'thumbnail';
        let pixallTagLabel = 'pht_gallery';
        // PSX VDP fire tag as 'thumbnail' for all images in media gallery modal
        if (index === 0 && title !== tabTitles.SPIN && (!isPsxVdp || par !== 'overlay')) {
            placement = 'primary';
        } else if (title === tabTitles.VIDEOS) {
            pixallTagLabel = 'vid_pht_gallery';
            placement = 'video';
        } else if (index === -1) {
            placement = 'view-all-media';
            pixallTagLabel = 'vw_all_media';
        } else if (title === tabTitles.SPIN) {
            placement = '360-spin';
            pixallTagLabel = '360_pht_gallery';
        }

        return { placement, pixallTagLabel, isPsxVdp, par };
    },

    mediaTabClick: ({
        title = '',
    } = {}) => {
        const type = title.replace(' ', '-').toLowerCase();
        let pixallTagLabel = '';
        if (type === 'photos') {
            pixallTagLabel = 'pht';
        } else if (type === 'video') {
            pixallTagLabel = 'vid';
        } else if (type === '360-view') {
            pixallTagLabel = '360';
        }
        return { type, pixallTagLabel };
    },

    mediaVideoPhotoClick: ({
        tab = '',
        photoCount = 0,
        videoCount = 0,
    } = {}) => {
        const type = tab.replace(' ', '-').toLowerCase();
        let pixallTagLabel = '';
        let tagIndex = '';
        if (type === 'photos') {
            pixallTagLabel = `photos::${photoCount}`;
            tagIndex = 'vdp-158';
        } else if (type === 'video') {
            pixallTagLabel = `videos::${videoCount}`;
            tagIndex = 'vdp-157';
        }
        return { type, pixallTagLabel, tagIndex };
    },

    mediaViewerPagination: ({
        currentSlide,
        fullScreenIndex,
    } = {}) => ({ direction: currentSlide - fullScreenIndex > 0 ? 'next' : 'previous' }),
};

export default function useMediaGalleryAnalytics() {
    return (type = 'click', functionName, data = {}) => {
        const analyticsData = getAnalyticsData[functionName]?.(data) || data;
        const { event = {} } = data;

        if (type === 'click') {
            sendClick(analyticsFunctions[functionName], event, analyticsData);
        } else if (type === 'impressions') {
            sendImpressions({ name: analyticsFunctions[functionName], data: { ...analyticsData } });
        }
    };
}
